const tab_sections = {
    overview: 'Visão geral',
    authentication: 'Autenticação',
    authorization: 'Autorização',
    users: 'Usuários',
    developer: 'Desenvolvedor',
    tenant: 'Inquilino',
};
export default Object.freeze(tab_sections);
